module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }